module.exports = __webpack_public_path__ + "static/media/moment13.45916841.webp";